<!--caja de comentario-->
<span  class="text-gray-500 text-sm" [innerHTML]="content.message | url"></span>
<div *ngIf="media">
	<media-holder [media]="media" [mini]="true" [width]="200" [pointer]="true" [previewFile]="true"></media-holder>


<!--<div class="post-link">
	<span *ngIf="content.link">
		<div *ngIf='!content?.link?.video'>
			<a class="post-url" target="_blank" [href]="content.link.pageUrl">
				<h3>{{ content.link.title }}</h3>
				<p>{{ content.link.description }}</p>
				<img [src]="content.link.image">
			</a>
		</div>

		<div *ngIf='content?.link?.video'>
			<a class="post-url" target="_blank" [href]="content.link.pageUrl">
				<h4>{{ content.link.title }}</h4>
				<p>{{ content.link.description }}</p>
				<span [innerHtml]="safeUrl"></span>
			</a>
		</div>
	</span>
</div>-->
